export const wmsParamReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'SET':
      localStorage.setItem('wmsParams', JSON.stringify(payload));
      return payload;
    case 'GET':
      return JSON.parse(localStorage.getItem('wmsParams'));
    default:
      return state;
  }
};
